import { render, staticRenderFns } from "./TargetDataDeliveryModal.vue?vue&type=template&id=be5fc4d8&scoped=true&"
import script from "./TargetDataDeliveryModal.vue?vue&type=script&lang=js&"
export * from "./TargetDataDeliveryModal.vue?vue&type=script&lang=js&"
import style0 from "./TargetDataDeliveryModal.vue?vue&type=style&index=0&id=be5fc4d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5fc4d8",
  null
  
)

export default component.exports